module.exports = __webpack_public_path__ + "static/media/5-1.231dc901.mp3";